import type { ISupervisionResponse } from '@modules/affiliates-approved/types';
import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import {
  AFFILIATES_APPROVED_PERMISSIONS,
  AFFILIATES_SUPERVISION_API_URL,
  AFFILIATES_SUPERVISION_MUTATION_KEY,
} from '../constants';

export default function useAffiliateSupervisionMutation(): IContextMutationResult<ISupervisionResponse, Error, number> {
  const { fetchPost } = useRestClient();

  return useContextMutation<ISupervisionResponse, Error, number>({
    mutationKey: [AFFILIATES_SUPERVISION_MUTATION_KEY],
    mutationFn: (id) => fetchPost<ISupervisionResponse>(
      AFFILIATES_SUPERVISION_API_URL,
      {},
      {
        permission: AFFILIATES_APPROVED_PERMISSIONS.SUPERVISION,
        urlParams: {
          id,
        },
      },
    ),
  });
}
